import React from "react";
import Select from "react-select";
import { RenderSecure } from "../../../util/script/RenderSecure";

const CallLogsSearchForm = ({
  caller,
  school,
  setCaller,
  setSchool,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  schoolList,
  searchCallLogs,
  resetSearch,
  setPage
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchCallLogs(e);
  };

  const handleReset = (e) => {
    e.preventDefault();
    resetSearch(e);
  };

  const handleCallerChange = (e) => {
    const value = e.target.value;
    setCaller(value);
    setPage(1);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
            <div className="col-lg-4">
              <input
                type="text"
                placeholder="Enter caller name..."
                style={{ border: "1px solid grey" }}
                value={caller}
                onChange={handleCallerChange}
                className="form-control"
              />
            </div>
            <RenderSecure code="ADMIN-VIEW"><div className="col-lg-3">
            <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      placeholder="Select school..."
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        school === ""
                          ? null
                          : Array.isArray(schoolList) &&
                            schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div></RenderSecure>
            <div className="col-lg-5">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini ml-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>
  );
};

export default CallLogsSearchForm;